import { render } from "./HistoryVehicle.vue?vue&type=template&id=53c4f874"
import script from "./HistoryVehicle.vue?vue&type=script&lang=js"
export * from "./HistoryVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script